module.exports = __webpack_public_path__ + "media/components/breakheader/background/background--9-2502572e8f035c05d074e164e170a7b9.jpg";